import dynamic from 'next/dynamic'
import { useState, useEffect } from 'react'
import Root from './root'
import Stats from './parts/stats/stats'
import Sort from './parts/sort/sort'
import Results from './parts/results/results'
import CurrentRefinements from './parts/current-refinements/current-refinements'
import Price from './parts/price/price'
import Taxonomy from './parts/taxonomy/taxonomy'
import Brand from './parts/brand/brand'
import Offers from './parts/offers/offers'
import styles from './hits.module.scss'
import { cn } from 'utils/helpers'
import Review from 'components/review/review'
import Infinite from 'components/infinite/infinite'
import AccountProfile2 from 'components/account-profile-2/account-profile-2'
// import AccountContact from 'components/account-contact/account-contact'
import addKeywords from 'utils/keywords'

const Deliveries = dynamic(() => import('components/deliveries/deliveries'))
const Privacy = dynamic(() => import('components/privacy/privacy'))

const reviewHolder = ({ items }) => {
    return (
        <div className="mb72">
            {items.map(item => (
                <Review key={item.id} item={item} useBorder />
            ))}
        </div>
    )
}

//function Side({ account, brand, mini, offers = false }) {
function Side({ brand, mini, offers = false }) {
    return (
        <>
            {/*<AccountContact account={account} />*/}
            <Price />
            <Taxonomy />
            {!mini && <Brand brand={brand} />}
            {!!offers && <Offers />}
        </>
    )
}

//function Meta({ tab, account, setTab }) {
function Meta({ tab, setTab }) {
    return (
        <>
            {/*<AccountProfile setTab={setTab} account={account} />*/}
            <div id="apie" className="ais-Meta ais-Meta-Account mb30">
                <div className={styles.tabs}>
                    <div onClick={() => setTab(0)} className={cn(tab === 0 && styles.active)}>
                        <Stats isAccount />
                    </div>
                    <div onClick={() => setTab(1)} className={cn(tab === 1 && styles.active)}>
                        Apie
                    </div>
                    <div onClick={() => setTab(2)} className={cn(tab === 2 && styles.active)}>
                        Siuntimas
                    </div>
                    <div onClick={() => setTab(3)} className={cn(tab === 3 && styles.active)}>
                        Atsiliepimai
                    </div>
                </div>
                {tab === 0 && <Sort def="products/sort/in_stock:desc,created_at:desc" />}
            </div>
        </>
    )
}

export default function Products({ account, brand, filter, hideRating }) {
    const [tab, setTab] = useState(0)
    const [showPrivacy, setShowPrivacy] = useState(false)
    const mini = account.simplified
    const offers = true

    console.log({filter})

    const handleSearch = () => {
        if (tab !== 0) {
            setTab(0)
        }
    }

    useEffect(() => {
        const hash = window.location.hash
        if (hash === '#apie') {
            setTab(1)
        }
    })

    return (
        <>
            <AccountProfile2 setTab={setTab} account={account} />
            <Root
                onSearch={handleSearch}
                mini={mini}
                account={account.slug}
                filter={filter}
                side={<Side account={account} mini={mini} brand={brand} offers={offers} />}
                meta={<Meta account={account} tab={tab} setTab={setTab} />}
            >
                <>
                    {tab === 0 && (
                        <>
                            <CurrentRefinements />
                            <Results hideRating={hideRating} />
                        </>
                    )}
                    {tab === 1 && (
                        <>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: addKeywords(account.description, [
                                        account.excerpt,
                                        account.short_description
                                    ])
                                }}
                            />
                            {account.privacy_policy_type && (
                                <div>
                                    <br />
                                    {showPrivacy || (
                                        <span onClick={() => setShowPrivacy(true)} className={styles.privacyLink}>
                                            Privatumo politika
                                        </span>
                                    )}
                                    {showPrivacy && (
                                        <div>
                                            {account.privacy_policy_type === 'generated' && (
                                                <Privacy account={account} />
                                            )}
                                            {account.privacy_policy_type === 'custom' && (
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: account.privacy_policy
                                                    }}
                                                />
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                        </>
                    )}
                    {tab === 2 && <Deliveries items={account.deliveries} />}
                    {tab === 3 && (
                        <Infinite endpoint={`reviews/${account.slug}`} component={Review} holder={reviewHolder} />
                    )}
                </>
            </Root>
        </>
    )
}
